export const FILE_UPLOAD_TEST_ID = 'file-upload-test-id'
export const SKELETONS_TEST_ID = 'skeletons-test-id'
export const TEXT_SKELETON_TEST_ID = 'text-skeleton-test-id'
